import $ from 'jquery'
import ModalCreerPatient from "@/components/creer-patient-modal";
// import VenteConsultation from '@/components/caisse/modal-prestations/m-consultation'
import VenteAnalyse from '@/components/caisse/modal-prestations/m-analyse'
import VenteExamen from '@/components/caisse/modal-prestations/m-examen'
import VenteAdmission from '@/components/caisse/modal-prestations/m-admission'
import VenteChambre from '@/components/caisse/modal-prestations/m-chambre'
import VenteObservation from '@/components/caisse/modal-prestations/m-observation'
import VenteActe from '@/components/caisse/modal-prestations/m-acte'
import VenteBilanSante from '@/components/caisse/modal-prestations/m-bilan-sante'
import VenteMedicament from '@/components/caisse/modal-prestations/m-medicament'
import VenteConsommable from '@/components/caisse/modal-prestations/m-consommable'
import VenteConsommableBon from '@/components/caisse/modal-prestations/m-consommable-bon'
import VenteChirurgie from '@/components/caisse/modal-prestations/m-chirurgies'
import AutrePrestation from '@/components/caisse/modal-prestations/autre-prestation'
import DeleteModal from '@/components/caisse/vente/ventes/delete-modal'
import ManageFactureComment from '@/components/caisse/factures/manage-facture-comment'
import EnteteBonEtFacture from '@/components/en-tete-bon-facture'
import { NumberToLetter } from 'convertir-nombre-lettre';
import store_patient from "@/store/mods/clinique/patients"
import ChoixPatientVente from '@/components/caisse/vente/choix-patient-vente'   // CAISSE-VDF
import store_operation from "@/store/mods/caisse/operations"

export default {
    name: 'ventes',
    components: {
        ModalCreerPatient, VenteAnalyse,
        VenteExamen, VenteAdmission, VenteChambre, 
        VenteObservation, VenteActe, VenteBilanSante, 
        VenteMedicament, VenteConsommable, VenteConsommableBon, 
        VenteChirurgie, AutrePrestation, EnteteBonEtFacture, DeleteModal, ChoixPatientVente,
        ManageFactureComment
    },
    props: [],
    data() {
        return {
            compte_id: 0,
            is_loading: false,
            is_load_error: false,
            curr_month: "",  

            all_checked: false,
            operations_to_pay: [],
            liste_operations_patient: [],

            is_printing: false,
            info_loading: false,
            creer_patient_monte: false,
            liste_patients_version: 0,
            error_message: '',

            other_prestation: {
                'slug': 'autre_prestation', 'libelle': 'Autres'
            },
            is_other_prestation: false,

            liste_prestation: [
                // { 'slug': 'consultation', 'libelle': 'Consultations' },
                { 'slug': 'analyse', 'libelle': 'Analyses' },
                { 'slug': 'examen', 'libelle': 'Examens' },
                { 'slug': 'medicament', 'libelle': 'Médicaments' },
                { 'slug': 'consommable', 'libelle': 'Consommables' },
                { 'slug': 'chirurgie', 'libelle': 'Chirurgies' },
                { 'slug': 'bilan_sante', 'libelle': 'Bilan de santé' },
                { 'slug': 'admission', 'libelle': 'Admissions' },
                { 'slug': 'acte', 'libelle': 'Actes' },
                { 'slug': 'observation', 'libelle': 'Observations' },
                { 'slug': 'chambre', 'libelle': 'Chambres' },
                { 'slug': 'consommable_bon', 'libelle': 'Consommables de bon de consultation' },
                { 'slug': 'autre_prestation', 'libelle': 'Autres' },
            ],
            type_prestations: [],
            other_type_prestations: "",
            selected_type_prestations: [],
            grouped_operations: [],
            proforma_operations: [],
            proforma_type_prestations: [],
            user_id: 0,

            chosen_type_client: '',
            patient: '',
            info_patient: {
                nom: '',
                prenoms: '',
                id: '',
                sexe: '',
                telephone_mobile: '',
                age: '',
            },
            is_sale: false,
            selected_aib: {
                libelle: '',
                taux: 0,
                slug: ''
            },

            tot_base_assurance: 0,
            total_prix_assureur: 0,
            total_prix_assure: 0,
            total_net_a_payer: 0,
            can_do_action: false,
            can_pay: false,
            is_reloading_tarif: false,
            warning_message: '',
            warning_contrat_expire: "",
            warning_prestations_exclues: [],
            warning_prestations: [],
            base_undefined_prestations: [],
            pac_undefined_prestations: [],
            warning_base_undefined: "",
            warning_pac_undefined: "",

            info_patient_assure: {},

            info_prestation: {
                libelle: '',
                slug: ''
            },
            water_mark_text: 'FACTURE PROFORMA',
            filename: '',
            refresh_state: 0,

            patient_loading: false,
            patient_empty: false,
            patient_search_loading: false,     // Recherche en cours dans la liste des patients
            patient_search_timer: null,
            patient_request_id: 0,             // Ignore les réponses d'une recherche devenue obsolète
            is_proforma: false,
            proforma_id: 0,
            title: '',
            save_loading: false,
            can_print: false,
            montant_en_lettre: '',
            await_loading: true,
            has_edit: false,
            sv_loading: false,
            liste_patients: [],

            colspans: {
                colspan_1: '',
                colspan_2: '',
            },
            info_caissier: {},
            format_ref_facture: "",
            can_show_autre_prestation_alert: false,
            info_froforma: {
                fpro_ref: '',
                fpro_commentaire: ''
            },
            fro_comment_toggler: 0,
            selected_slug: ''
        }
    },

    watch: {
        chosen_type_client() {
            this.error_message = ""

            // CAISSE-VDF : le tableau des patients (ChoixPatientVente) charge lui-même la liste, page par page
        },

        patient() {
            this.error_message = ""
        },

        operations_to_pay() {
            if (this.operations_to_pay.length == 0) {
                this.total_net_a_payer = 0
                this.can_do_action = false
                this.resetErrors()
                return;
            }

            // Check if can show alert for autre prestation
            this.showAlertForAutrePrestation()

            this.can_do_action = true
            this.calculateBill()
        },
    },

    computed: {
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        activeRole() {
            return this.$store.getters['activeRole'];
        },

        // info_patient_assure() {
        //     return this.$store.getters["info_patient_assure"];
        // },

        can_add_differential_computing() {
            return this.$store.getters["can_add_differential_computing"]
        },

        chosen_patient() {
            return this.$store.getters["chosen_patient"];
        },

        etat_ouverture_caisse() {
            return this.$store.getters['etat_ouverture_caisse'];
        },

        patient_insurance_info() {
            return this.$store.getters['patient_insurance_info']
        },

        tauxCouvertureGeneral() {
            const valeur = this.info_patient_assure.taux_general
            if ((typeof valeur !== 'number' && typeof valeur !== 'string') || String(valeur).trim() === '') return 'Non renseigné'
            const fraction = Number(valeur)
            if (!Number.isFinite(fraction) || fraction < 0 || fraction > 1) return 'Non renseigné'
            return (fraction * 100).toLocaleString('fr-FR', { maximumFractionDigits: 10 }) + ' %'
        },

        divers_info() {
            return this.$store.getters["divers_info"];
        },
    },

    mounted() {
        // this.$store.commit("SET_CHOSEN_PATIENT", {});

        if (this.has_two_currencies) {
            this.currency_info = this.$store.getters['info_currency']
        }

        if (this.userCredentials.user.roles.length > 0) {
            this.user_id = this.userCredentials.user.id

            if (this.activeRole.nom == 'ROLE_CAISSIERE') {
                this.compte_id = 1 //  Caisse principale
            } else if (this.activeRole.nom == 'ROLE_CAISSIERE_INTERMITENT') {
                this.compte_id = 4 //  Caisse 1 (Infirmier)
            } else if (this.activeRole.nom == 'ROLE_COMPTABLE') {
                this.compte_id = 3 //  Comptabilité
            }
        }
        this.info_caissier = {
            nom_caissier: this.userCredentials.user.name,
            titre: this.userCredentials.user.titre
        }

        this.$store.commit("SET_PATIENT_INSURANCE_INFO", {});
        

        this.setColspans()

        this.checkRegisterCashStatus(this.compte_id)        // Function defined in util-mixins.js

        this.user_id = this.userCredentials.user.id
        this.curr_month = this.monthOfYear[this.current_date.getMonth() + 1]

        // Check if Differential computing should be applied
        this.$store.dispatch('getDifferentialComputing')

        this.$store.commit("SET_IS_PAID", false);
        
        // Check if is facture proforma
        this.is_proforma = (this.$router.history.current.name == 'Vente')?false:true
        this.chosen_type_client = (this.is_proforma)?'patient':''
        this.title = (this.is_proforma)?'Facture proforma':'Ventes'

        if (this.is_proforma) {
            this.proforma_id =  parseInt(this.$route.params.proforma_id)

            if (this.proforma_id > 0) {
                this.fetchInfoFproforma()
            }

            this.nextToSale()
        }

        this.getDiversInfo()
    },

    methods: {
        ouvrirCreationPatient() {
            this.creer_patient_monte = true
            this.$nextTick(() => $('#add-patient').modal('show'))
        },

        showAlertForAutrePrestation() {
            let can_show = false
            this.operations_to_pay.forEach(operation => {
                if (operation.data_type == 'autre_prestation') {
                    can_show = true
                }
            });
            this.can_show_autre_prestation_alert = can_show
        },

        addComment() {
            this.fro_comment_toggler = (this.fro_comment_toggler == 0)?1:0

            $('.manage-facture-comment').modal('show')
        },

        getDiversInfo() {
            this.$store.dispatch('getConfigInfoClinique', 'divers_info').then(() => {
                this.format_ref_facture = this.divers_info.format_ref_facture
            })
        },

        getInsuranceInfo(patient_id) {
            this.info_loading = true
            this.$store.dispatch('getPatientInsuranceInfo', patient_id).then(() => {
                if (!this.InsuranceIsValid(this.patient_insurance_info.contrat_a_expire)) {
                    this.warning_contrat_expire = "Le contrat d'assurrance de ce patient est expiré. En continuant, le patient sera traité comme un patient non assuré."
                }

                this.info_patient_assure = {
                    assurance: this.patient_insurance_info.assur_nom,
                    assurance_id: this.patient_insurance_info.assur_id,
                    est_assure: this.patient_insurance_info.est_assure,
                    societe_souscripteur: this.patient_insurance_info.souscripteur,
                    taux_general: this.patient_insurance_info.taux_general,
                    est_expire: this.patient_insurance_info.contrat_a_expire 
                }

                this.info_loading = false
                this.is_sale = true
            })
        },

        setColspans() {
            if (this.can_set_pac) {
                this.colspans.colspan_1 = 13
                this.colspans.colspan_2 = 12
            } else {
                this.colspans.colspan_1 = 11
                this.colspans.colspan_2 = 10
            }
        },

        /**
         * Liste initiale : les patients les plus récents (la recherche se fait ensuite côté serveur)
         */
        fetchPatient() {
            this.patient_loading = true 
            this.loadPatients('').then(() => {
                this.patient_empty = (this.liste_patients.length == 0)
                this.patient_loading = false 
            })
        },

        /**
         * Recherche saisie dans la liste des patients (nom, prénoms, N° dossier, téléphone)
         */
        searchPatients(query) {
            clearTimeout(this.patient_search_timer)
            this.patient_search_timer = setTimeout(() => {
                this.loadPatients(query)
            }, 300)
        },

        loadPatients(search) {
            const request_id = ++this.patient_request_id
            this.patient_search_loading = true

            return store_patient.searchPatientsForSale(search || '', 30).then((patients) => {
                if (request_id != this.patient_request_id) return
                this.liste_patients = patients
                this.patient_search_loading = false
            }).catch(() => {
                if (request_id != this.patient_request_id) return
                this.patient_search_loading = false
            })
        },

        saveChanges() {
            let data = {
                user_id: this.user_id,
                est_assure: this.info_patient_assure.est_assure,
                prestations: this.liste_operations_patient,
                can_add_differential_computing: this.can_add_differential_computing.response
            }

            this.sv_loading = true
            this.$store.dispatch('updateOperationAttente', data).then((response) => {
                if (response.success) {
                    this.successToast("Opération enregistrée avec succès")
                    this.has_edit = false
                    this.fetchOperationVente(this.proforma_id)
                } else {
                    if (response.code == 401) {
                        this.warningToast('Merci de choisir les prestations à enregistrer')
                    } else if (response.code == 422) {
                        this.warningToast(response.message || 'Prix unitaire invalide')
                    } else if (response.code == 501) {
                        this.warningToast('Une erreur s\'est produite ! Merci de réessayer plustard')
                    } 
                }
                this.sv_loading = false
                $('.auto-save').modal('hide')

            }).catch(() => {
                this.warningToast('Une erreur s\'est produite ! Merci de réessayer plustard')
                this.sv_loading = false
                $('.auto-save').modal('hide')
            })
        },

        refreshListPrestation(slug) {
            this.selected_slug = slug
            if (this.has_edit) {
                this.warningToast("Merci d'enregistrer les modifications avant de continuer.")
                return;
            }
            
            $('.v-'+slug).modal('show')
            this.refresh_state = (this.refresh_state == 0)?1:0
        },

        categorieEstSelectionnee(slug) {
            return this.type_prestations.some(item => item.slug === slug)
        },

        ouvrirCategoriePrestation(prestation) {
            if (this.has_edit) {
                this.warningToast("Merci d'enregistrer les modifications avant de continuer.")
                return
            }
            if (!this.categorieEstSelectionnee(prestation.slug)) this.type_prestations.push(prestation)
            this.refreshListPrestation(prestation.slug)
        },

        checkAll() {
            let is_checked = $('#check-all').is(":checked")

            if (is_checked) {
                this.operations_to_pay = []

                this.grouped_operations.forEach((operation) => {
                    operation.prestations.forEach(prestation => {
                        this.operations_to_pay.push(prestation)
                    });
                    
                });
                this.all_checked = true
                
            } else {
                this.operations_to_pay = []
                this.all_checked = false
            }
        },

        onOneChange() {
            document.getElementById("check-all").checked = false;
        },

        scrollTo(anchor, selector) {
            var p = document.getElementById(selector)
            if (p.checked) {
                setTimeout(() => {
                    let scroll_value = $('#s-'+anchor).offset().top
                    $('#s-anchor').animate({
                        scrollTop: scroll_value
                    }, 800, function() {});
                }, 1000);
            }
        },

        nextToSale() {
            this.$store.commit("SET_INFO_PATIENT_ASSURE", {});
            
            if (this.proforma_id == 0) {
                if (this.chosen_type_client == '' || (this.chosen_type_client == 'patient' && this.patient == '')) {
                    this.error_message = "Merci de choisir le client !"
                    return;
                }

                this.info_loading = true

                this.info_patient = {
                    nom: (this.chosen_type_client == 'client_divers')?'Client divers':this.patient.patient_nom,
                    prenoms: '',
                    id: (this.chosen_type_client == 'client_divers')?0:this.patient.patient_id,
                    sexe: (this.chosen_type_client == 'client_divers')?'':this.patient.sexe,
                    telephone_mobile: (this.chosen_type_client == 'client_divers')?'':this.patient.patient_telephone,
                    age: (this.chosen_type_client == 'client_divers')?'':this.patient.age,
                    ref_fpro: '',
                    num_dossier: (this.chosen_type_client == 'client_divers')?'':this.patient.patient_code
                }

                if (this.chosen_type_client == 'patient') {
                    this.getInsuranceInfo(this.patient.patient_id)
                    // this.getInfoPatientAssure(this.patient.patient_id)
                } else {
                    this.info_loading = false
                    this.is_sale = true
                }
            } else {
                this.info_loading = true
                
                this.info_patient = {
                    nom: this.chosen_patient.nom,
                    prenoms: '',
                    id: this.chosen_patient.id,
                    sexe: this.chosen_patient.sexe,
                    telephone_mobile: this.chosen_patient.telephone_mobile,
                    age: this.chosen_patient.age,
                    ref_fpro: this.chosen_patient.ref_fpro,
                    user: this.chosen_patient.user,
                    num_dossier: this.chosen_patient.num_dossier
                }

                this.getInsuranceInfo(this.chosen_patient.id)
                // this.getInfoPatientAssure(this.chosen_patient.id)
            }

            const tmpstamp = this.current_date.getTime()
            this.filename = 'Facture-Proforma_'+this.info_patient.nom+'_'+tmpstamp

            this.fetchOperationVente(this.proforma_id)
        },

        backToPatientChoice() {
            this.$store.commit("SET_INFO_PATIENT_ASSURE", {});
            this.patient = ''
            this.is_sale = false
        },

        getInfoPatientAssure(patient_id) {
            this.$store.dispatch('getInfoPatientAssure', patient_id).then(() => {
                this.info_loading = false
                this.is_sale = true
            })
        },

        setBillingPatient(info) {
            this.liste_patients_version++
            this.patient = {
                patient_id: info.patient_id,
                patient_nom: info.patient_nom,
                sexe: info.patient_sexe,
                age: info.patient_age,
                patient_telephone: info.patient_telephone,
                num_dossier: info.num_dossier,
                patient_code: info.num_dossier
            }
            // CAISSE-VDF : le patient créé ouvre directement la vente
            this.chosen_type_client = 'patient'
            if (!this.is_sale) this.nextToSale()
        },

        // CAISSE-VDF : choix dans le tableau des patients → vente ouverte pour ce patient
        choisirPatient(patient) {
            if (!patient || !patient.patient_id || this.info_loading) return
            this.chosen_type_client = 'patient'
            this.patient = patient
            this.nextToSale()
        },

        choisirClientDivers() {
            if (this.is_proforma || this.info_loading) return
            this.chosen_type_client = 'client_divers'
            this.patient = ''
            this.nextToSale()
        },

        fetchOperationVente(proforma_id) {
            this.can_show_autre_prestation_alert = false
            this.proforma_id = proforma_id
            const data = {
                is_vente_caisse: 1,
                month: "",
                one_date: "",
                from_date: "",
                to_date: "",
                etat_paiement: 0,
                patient_id: this.info_patient.id,
                aib: this.selected_aib.slug,
                proforma_id: proforma_id,
                is_proforma: this.is_proforma
            }
            this.current_date_filter = data

            this.fetchInfoFproforma()
            this.getListeOperations(data)
            this.has_edit = false
        },

        resetErrors() {
            this.base_undefined_prestations = []
            this.pac_undefined_prestations = []
            this.warning_prestations = []
            this.warning_prestations_exclues = []
            this.warning_message = ""
            this.warning_base_undefined = ""
            this.warning_pac_undefined = ""
            this.can_do_action = false
        },

        resetValues() {
            this.$store.commit("SET_LISTE_OPERATIONS_PATIENT", []);
            
            this.base_undefined_prestations = []
            this.pac_undefined_prestations = []
            this.grouped_operations = []
            this.type_prestations = []
            this.warning_prestations = []
            this.warning_prestations_exclues = []
            this.warning_message = ""
            this.warning_base_undefined = ""
            this.warning_pac_undefined = ""
            this.can_do_action = false
        },

        fetchInfoFproforma() {
            // Vente sans facture proforma : rien à charger
            if (!this.proforma_id) {
                this.info_froforma = { fpro_ref: '', fpro_commentaire: '' }
                return
            }
            store_operation.getInfoProforma(this.proforma_id).then((info) => {
                this.info_froforma = {
                    fpro_ref: info.fpro_ref,
                    fpro_commentaire: info.fpro_commentaire
                }
            })
        },

        getListeOperations(data) {
            this.await_loading = true
            this.operations_to_pay = []
            this.resetValues()

            this.is_load_error = false
            this.is_loading = true

            
            store_operation.getListeOperationsPatient(data).then((operations) => {
                this.liste_operations_patient = operations.map(prestation => ({
                    ...prestation,
                    prix_initial_manquant: prestation.data_type === 'analyse' && Number(prestation.prix_unitaire) <= 0
                })).sort((a, b) => String(a.date || '').localeCompare(String(b.date || '')) ||
                    (Number(a.operation_id) || 0) - (Number(b.operation_id) || 0))
                if (this.liste_operations_patient.length > 0) {
                    this.groupOperationsPatient()
                    this.is_empty = false
                } else {
                    this.is_empty = true
                }

                this.is_loading = false
            }).catch(() => {
                this.is_load_error = true
                this.is_loading = false
            })
        },

        async groupOperationsPatient() {
            Array.prototype.groupBy = function (key) {
                return this
                    .reduce((hash, obj) => {
                        if (obj[key] === undefined) return hash;
                        return Object.assign(hash, { [obj[key]]: (hash[obj[key]] || []).concat(obj) })
                    }, {})
            };

            const tmp_grouped_operations = this.liste_operations_patient.groupBy('data_type')
            this.grouped_operations = []
            this.type_prestations = []

            for (const key in tmp_grouped_operations) {

                if (key == 'chirurgie') {
                    const tmp_grouped_prestations = tmp_grouped_operations[key].groupBy('chirurgie')

                    for (const key_prest in tmp_grouped_prestations) {
                        const tmp_group = {
                            data_type: key,
                            group_prestation: tmp_grouped_operations[key][0].group_prestation,
                            prestations: tmp_grouped_prestations[key_prest],
                            chirurgie: key_prest,
                            taux_assurance: tmp_grouped_operations[key][0].taux_assurance,
                            aib: tmp_grouped_operations[key][0].aib
                        } 
                        this.grouped_operations.push(tmp_group) 
                    }
                } else {
                    const tmp_group = {
                        data_type: key,
                        group_prestation: tmp_grouped_operations[key][0].group_prestation,
                        prestations: tmp_grouped_operations[key],
                        taux_assurance: tmp_grouped_operations[key][0].taux_assurance,
                        aib: tmp_grouped_operations[key][0].aib
                    }
                    this.grouped_operations.push(tmp_group)
                }

                let tmp_prestation = { 
                    'slug': key, 
                    'libelle': tmp_grouped_operations[key][0].group_prestation
                }
                this.type_prestations.push(tmp_prestation)
            }
            setTimeout(() => {
                this.refetch()
            }, 1000);
            
            
        },

        refetch() {
            setTimeout(() => {
                let len_type_prestation =  this.type_prestations.length
                const is_refresh = true
                for (let ti = 0; ti < len_type_prestation; ti++) {
                    for (let ix = 0; ix < this.grouped_operations.length; ix++) {
                        for (let jx = 0;  jx < this.grouped_operations[ix].prestations.length; jx++) {
                            this.handleQtyChange(ti, ix, jx, is_refresh)
                        }
                    }
                }
            }, 1000);
        },

        calculatePartAssureur(param_assure) {
            let part_assureur = 0
            let total_pac =  param_assure.prix_assure_clinique * param_assure.qte
            let tmp_part_assureur = 0
            if (param_assure.base_assurance > 0) {
                tmp_part_assureur = parseInt( (param_assure.taux_couverture * param_assure.base_assurance * param_assure.qte) / 100) 
            }

            if (this.can_set_pac) {
                if (total_pac <= tmp_part_assureur) {
                    part_assureur = total_pac
                } else {
                    part_assureur = tmp_part_assureur
                }
            } else {
                part_assureur = tmp_part_assureur
            }
            return part_assureur;
        },

        calculatePartAssure(param_assure) {
            let part_assure = 0
            if (param_assure.est_exclu == 0 && param_assure.base_assurance > 0) {
                if (this.can_set_pac && param_assure.prix_assure_clinique < param_assure.base_assurance) {
                    let tmp_part_assureur = 0
                    if (param_assure.base_assurance > 0) {
                        tmp_part_assureur = parseInt( (param_assure.taux_couverture * param_assure.base_assurance * param_assure.qte) / 100)
                    }

                    let total_pac = 0
                    if (param_assure.prix_assure_clinique > 0) {
                        total_pac =  param_assure.prix_assure_clinique * param_assure.qte

                        if (total_pac <= tmp_part_assureur) {
                            part_assure = 0
                        } else {
                            part_assure = total_pac - tmp_part_assureur
                        }
                    }
                } else {
                    if (this.can_add_differential_computing.response == "Oui") {
                        let pac = 0
                        if (this.can_set_pac) {
                            pac = (param_assure.prix_assure_clinique === '')?param_assure.pu:param_assure.prix_assure_clinique
                        } else {
                            pac = param_assure.pu
                        }

                        const prix_additionnel = (pac > param_assure.base_assurance)?(pac - param_assure.base_assurance):0
                        part_assure = Math.ceil( ( ( (100 - param_assure.taux_couverture) / 100 ) * param_assure.base_assurance ) +
                            +  parseInt(prix_additionnel) ) * param_assure.qte
                    } else {
                        part_assure = ( Math.ceil( ( (100 - param_assure.taux_couverture) / 100 ) * param_assure.base_assurance ) * param_assure.qte)
                    }
                }
            } else {
                if (this.can_set_pac && this.info_patient_assure.est_assure) {
                    part_assure = 0
                } else {
                    part_assure = param_assure.qte * param_assure.pu
                }
            }

            return part_assure;
        },

        handleUnpricedAnalysisPrice(g_index, p_index, event) {
            const prestation = this.grouped_operations[g_index].prestations[p_index]
            const saisie = String(event.target.value || '').trim()
            if (saisie !== '' && !/^\d+$/.test(saisie)) {
                this.warningToast('Le prix doit être un montant entier positif.')
                return
            }

            const prix = saisie === '' ? 0 : Number(saisie)
            prestation.prix_unitaire = prix
            const quantite = Number(prestation.tmp_qte || prestation.qte || 1)

            if (this.info_patient_assure.est_assure && prestation.can_apply_insurance_rate && !prestation.est_exclu) {
                const param_assure = {
                    base_assurance: prestation.tmp_base_assurance,
                    prix_assure_clinique: prestation.tmp_prix_assure_clinique,
                    taux_couverture: prestation.tmp_taux_assurance,
                    pu: prix,
                    qte: quantite,
                    est_exclu: prestation.est_exclu
                }
                prestation.montant_net_a_solder = this.calculatePartAssure(param_assure)
                prestation.part_assureur = this.calculatePartAssureur(param_assure)
            } else {
                prestation.montant_net_a_solder = prix * quantite
            }

            this.has_edit = true
            this.calculateBill()
        },

        handleBaseAssuranceChange (t_index, g_index, p_index, is_base_assur) {
            const qty = this.grouped_operations[g_index].prestations[p_index].tmp_qte
            const prix_unitaire = this.grouped_operations[g_index].prestations[p_index].prix_unitaire
            const rate = this.grouped_operations[g_index].prestations[p_index].tmp_taux_assurance;
            let prix_assure_clinique = ''
            let base_assurance = ''

            if (is_base_assur) {    // Modification de la base assurance
                prix_assure_clinique = this.grouped_operations[g_index].prestations[p_index].tmp_prix_assure_clinique

                const input_base = document.getElementById('bs-'+t_index+''+g_index+''+p_index)
                if (!input_base) {
                    return;
                }

                base_assurance = input_base.value

                const base_assur_is_empty = this.validateStringNotEmpty(base_assurance)
                if (!base_assur_is_empty) {
                    base_assurance = this.transformToNumber(base_assurance)
                } else {
                    base_assurance = 0
                }
            } else {  // Modification du Prix Assuré Clinique
                base_assurance = this.grouped_operations[g_index].prestations[p_index].tmp_base_assurance

                const input_pac = document.getElementById('pacbs-'+t_index+''+g_index+''+p_index)
                if (!input_pac) {
                    return;
                }
                
                prix_assure_clinique = input_pac.value

                const pac_is_empty = this.validateStringNotEmpty(prix_assure_clinique)
                if (!pac_is_empty) {
                    prix_assure_clinique = this.transformToNumber(prix_assure_clinique)
                } else {
                    prix_assure_clinique = 0
                }
            }

            this.grouped_operations[g_index].prestations[p_index].tmp_prix_assure_clinique = prix_assure_clinique
            this.grouped_operations[g_index].prestations[p_index].tmp_base_assurance = base_assurance

            // Calcul montant a payer
            let montant_a_payer = 0
            if (this.patient_insurance_info.est_assure && this.grouped_operations[g_index].prestations[p_index].can_apply_insurance_rate) {
                const est_exclu = this.grouped_operations[g_index].prestations[p_index].est_exclu

                const param_assure = {
                    base_assurance: base_assurance,
                    prix_assure_clinique: prix_assure_clinique,
                    taux_couverture: rate,
                    pu: prix_unitaire,
                    qte: qty,
                    est_exclu: est_exclu
                }

                montant_a_payer = this.calculatePartAssure(param_assure)
                this.grouped_operations[g_index].prestations[p_index].part_assureur = this.calculatePartAssureur(param_assure)
            } else {
                montant_a_payer = prix_unitaire * qty
            }
            
            this.grouped_operations[g_index].prestations[p_index]['montant_net_a_solder'] = montant_a_payer
            this.calculateBill()
            this.has_edit = true
        },

        handleRateChange(t_index, g_index, p_index) {
            const qty = this.grouped_operations[g_index].prestations[p_index].tmp_qte
            const base_assurance = this.grouped_operations[g_index].prestations[p_index].tmp_base_assurance
            const prix_unitaire = this.grouped_operations[g_index].prestations[p_index].prix_unitaire
            const initial_rate = this.grouped_operations[g_index].prestations[p_index].taux_assurance;
            const prix_assure_clinique = this.grouped_operations[g_index].prestations[p_index].tmp_prix_assure_clinique

            // Get entry rate
            const input_rate = document.getElementById('tx-'+t_index+''+g_index+''+p_index)
            if (!input_rate) {
                return;
            }

            let rate = input_rate.value
            if (rate === '') {
                input_rate.value = 0
                this.calculateBill()
            }

            if (rate < 0 || rate > 100) {
                this.warningToast('Le taux assurance doit être compris entre 0 et 100 !')
                input_rate.value = initial_rate
                return;
            }

            // Calcul montant a payer
            let montant_a_payer = 0
            if (this.patient_insurance_info.est_assure && this.grouped_operations[g_index].prestations[p_index].can_apply_insurance_rate) {
                const est_exclu = this.grouped_operations[g_index].prestations[p_index].est_exclu

                const param_assure = {
                    base_assurance: base_assurance,
                    prix_assure_clinique: prix_assure_clinique,
                    taux_couverture: rate,
                    pu: prix_unitaire,
                    qte: qty,
                    est_exclu: est_exclu
                }
                montant_a_payer = this.calculatePartAssure(param_assure)
                this.grouped_operations[g_index].prestations[p_index].part_assureur = this.calculatePartAssureur(param_assure)
            } else {
                montant_a_payer = prix_unitaire * qty
            }

            this.grouped_operations[g_index].prestations[p_index].tmp_taux_assurance = rate
 
            this.grouped_operations[g_index].prestations[p_index]['montant_net_a_solder'] = montant_a_payer

            this.calculateBill()
            this.has_edit = true
        },

        handleQtyChange(t_index, g_index, p_index, is_refresh=false) {
            const initial_qty = this.grouped_operations[g_index].prestations[p_index].qte;
            let base_assurance = 0
            let taux_couverture = 0
            const prix_unitaire = this.grouped_operations[g_index].prestations[p_index].prix_unitaire


            let input_qty = document.getElementById('qty-'+t_index+''+g_index+''+p_index)

            if (!input_qty) {
                return;
            }

            let qty = input_qty.value
            qty = this.cleanNumber(qty)
            if (qty === '') {
                return;
            }

            const is_greater_zero = this.checkIfNumberGreaterThanZero(qty)
            if (!is_greater_zero) {
                this.warningToast('Merci de saisir une valeur supérieure à 0 !')
                input_qty.value = initial_qty
                this.calculateBill()
                // this.setPrestationToBePaid()
                return;
            }
            
            this.grouped_operations[g_index].prestations[p_index].qte = qty
            this.grouped_operations[g_index].prestations[p_index].tmp_qte = qty

            // Calcul montant a payer
            let montant_a_payer = 0
            let can_apply_insurance_rate = this.grouped_operations[g_index].prestations[p_index].can_apply_insurance_rate 
            let est_exclu = this.grouped_operations[g_index].prestations[p_index].est_exclu

            if (this.info_patient_assure.est_assure && can_apply_insurance_rate && est_exclu == 0) {
                base_assurance = this.grouped_operations[g_index].prestations[p_index].base_assurance
                taux_couverture = this.grouped_operations[g_index].prestations[p_index].taux_assurance
                let prix_assure_clinique = this.grouped_operations[g_index].prestations[p_index].prix_assure_clinique

                const param_assure = {
                    base_assurance: base_assurance,
                    prix_assure_clinique: prix_assure_clinique,
                    taux_couverture: taux_couverture,
                    pu: prix_unitaire,
                    qte: qty,
                    est_exclu: est_exclu
                }

                montant_a_payer = this.calculatePartAssure(param_assure)
                
                this.grouped_operations[g_index].prestations[p_index].part_assureur = this.calculatePartAssureur(param_assure)
            } else {
                montant_a_payer = prix_unitaire * qty
            }

            this.grouped_operations[g_index].prestations[p_index]['montant_net_a_solder']  = montant_a_payer
            this.calculateBill()

            if (!is_refresh) this.has_edit = true
        }, 

        validatePayment() {
            this.base_undefined_prestations = []
            this.pac_undefined_prestations = []
            this.warning_prestations = []
            this.warning_prestations_exclues = []
            this.warning_message = ""
            this.warning_base_undefined = ""
            this.warning_pac_undefined = ""
            let one_price_is_undefined = false
            let one_base_is_undefined = false

            this.operations_to_pay.forEach(operation => {
                let montant = operation.prix_unitaire
                montant = this.cleanNumber(montant)

                if (montant === '' || (operation.data_type === 'analyse' && Number(montant) <= 0)) {
                    this.error_message = operation.data_type === 'analyse'
                        ? 'Renseignez le prix de chaque analyse sélectionnée avant le paiement.'
                        : "Le prix d'une ou plusieurs prestations n'a pas été défini."
                    one_price_is_undefined = true
                    this.warning_prestations.push(
                        {
                            libelle: operation.libelle
                        }
                    )
                }

                if (one_price_is_undefined) {
                    return;
                }

                if (operation.est_exclu == 1) {
                    this.warning_message = "Une ou plusieurs prestations ont été exclues. En continuant, le patient paiera la totalité des prestations concernées"
                    this.warning_prestations_exclues.push(
                        {
                            libelle: operation.libelle
                        }
                    )
                }

                if (this.info_patient_assure.est_assure === 1) {             // --->> DECOMMENTER POUR BLOQUER SI TAUX OU ASE ASSURANCE NON DEFINI
                    let base_assurance = operation.base_assurance

                    if ((base_assurance == null || base_assurance === '') && operation.can_apply_insurance_rate === 1 && operation.est_exclu == 0) {
                        this.warning_base_undefined = "La base assurance ou le taux d'une ou plusieurs prestations n'ont pas été définis"
                        this.base_undefined_prestations.push(
                            {
                                libelle: operation.libelle
                            }
                        )
                    }

                    if (
                        this.can_set_pac && operation.can_apply_insurance_rate && 
                        operation.est_exclu == 0 && 
                        (operation.prix_assure_clinique == null || operation.prix_assure_clinique === '')
                    ) {
                        this.warning_pac_undefined = "Le prix assuré d'une ou plusieurs prestations n'a pas été défini"

                        this.pac_undefined_prestations.push(
                            {
                                libelle: operation.libelle
                            }
                        )
                    }
                }
            });

            if (one_price_is_undefined || one_base_is_undefined) {
                this.can_pay = false
                return;
            }
            this.error_message = ''
            this.can_pay = true
        },

        calculateBill() {
            this.is_reloading_tarif = true
            this.validatePayment()

            this.total_net_a_payer = 0
            this.tot_base_assurance = 0
            this.total_prix_assure = 0
            this.total_prix_assureur = 0


            if (this.can_pay) {
                this.operations_to_pay.forEach(operation => {
                    let montant = operation.montant_net_a_solder
                    montant = this.cleanNumber(montant)

                    if (operation.data_type == 'apport_social') {
                        montant = -montant
                    }
    
                    this.total_net_a_payer += montant
                    if (operation.base_assurance > 0) {
                        this.tot_base_assurance += (parseInt(operation.base_assurance) * operation.tmp_qte)
                    }
                    
                    this.total_prix_assureur += operation.part_assureur
                });
                this.total_prix_assure = this.total_net_a_payer
            }
            this.is_reloading_tarif = false

            this.montant_en_lettre = NumberToLetter(this.total_net_a_payer)
        },

        handleOtherPrestation(prestation) {
            this.info_prestation = prestation

            $('.add-oth-'+prestation.slug).modal('show')
        },

        setSelectedOperations() {
            Array.prototype.groupBy = function (key) {
                return this
                    .reduce((hash, obj) => {
                        if (obj[key] === undefined) return hash;
                        return Object.assign(hash, { [obj[key]]: (hash[obj[key]] || []).concat(obj) })
                    }, {})
            };

            const tmp_grouped_operations = this.operations_to_pay.groupBy('data_type')
            let grouped_operations = []

            for (const key in tmp_grouped_operations) {

                if (key == 'chirurgie') {
                    const tmp_grouped_prestations = tmp_grouped_operations[key].groupBy('chirurgie')

                    for (const key_prest in tmp_grouped_prestations) {
                        const tmp_group = {
                            data_type: key,
                            group_prestation: tmp_grouped_operations[key][0].group_prestation,
                            prestations: tmp_grouped_prestations[key_prest],
                            chirurgie: key_prest,
                            taux_assurance: tmp_grouped_operations[key][0].taux_assurance,
                            aib: tmp_grouped_operations[key][0].aib
                        } 
                        grouped_operations.push(tmp_group) 
                    }
                } else {
                    const tmp_group = {
                        data_type: key,
                        group_prestation: tmp_grouped_operations[key][0].group_prestation,
                        prestations: tmp_grouped_operations[key],
                        taux_assurance: tmp_grouped_operations[key][0].taux_assurance,
                        aib: tmp_grouped_operations[key][0].aib
                    }
                    grouped_operations.push(tmp_group)
                }

                let tmp_prestation = { 
                    'slug': key, 
                    'libelle': tmp_grouped_operations[key][0].group_prestation
                }
                this.proforma_type_prestations.push(tmp_prestation)
            }
            return grouped_operations
        },

        goToPayment() {
            if (this.has_edit) {
                this.warningToast("Merci d'enregistrer les modifications avant de continuer.")
                return;
            }

            let grouped_operations = this.setSelectedOperations()
            const filtered_grouped_operations = grouped_operations.filter(item => item.data_type !== 'autre_prestation');

            this.$store.commit("SET_BILL_SELECTED_OPERATIONS", filtered_grouped_operations);
            
            const selected_patient = {
                patient_id: this.info_patient.id,
                nom_patient: this.info_patient.nom,
                sexe: this.info_patient.sexe,
                telephone_mobile: this.info_patient.telephone_mobile,
                age: this.info_patient.age,
                num_dossier: this.info_patient.num_dossier
            }
            this.$store.commit("SET_PATIENT", selected_patient);
            this.$store.commit("SET_IS_VENTE_FROM_CAISSE", 1);
            this.$store.commit("SET_PAYING_BILL_STATE", 0);

            setTimeout(() => {
                this.$router.push({ path: '/factures/paiement' })
            }, 500);
        },

        printProforma() {
            this.proforma_operations = []
            this.proforma_type_prestations = []
            
            Array.prototype.groupBy = function (key) {
                return this
                    .reduce((hash, obj) => {
                        if (obj[key] === undefined) return hash;
                        return Object.assign(hash, { [obj[key]]: (hash[obj[key]] || []).concat(obj) })
                    }, {})
            };

            const tmp_grouped_operations = this.operations_to_pay.groupBy('data_type')
           

            for (const key in tmp_grouped_operations) {

                if (key == 'chirurgie') {
                    const tmp_grouped_prestations = tmp_grouped_operations[key].groupBy('chirurgie')

                    for (const key_prest in tmp_grouped_prestations) {
                        const tmp_group = {
                            data_type: key,
                            group_prestation: tmp_grouped_operations[key][0].group_prestation,
                            prestations: tmp_grouped_prestations[key_prest],
                            chirurgie: key_prest,
                            taux_assurance: tmp_grouped_operations[key][0].taux_assurance,
                            aib: tmp_grouped_operations[key][0].aib
                        } 
                        this.proforma_operations.push(tmp_group) 
                    }
                } else {
                    const tmp_group = {
                        data_type: key,
                        group_prestation: tmp_grouped_operations[key][0].group_prestation,
                        prestations: tmp_grouped_operations[key],
                        taux_assurance: tmp_grouped_operations[key][0].taux_assurance,
                        aib: tmp_grouped_operations[key][0].aib
                    }
                    this.proforma_operations.push(tmp_group)
                }

                let tmp_prestation = { 
                    'slug': key, 
                    'libelle': tmp_grouped_operations[key][0].group_prestation
                }
                this.proforma_type_prestations.push(tmp_prestation)
            }

            this.can_print = true
            setTimeout(() => {
                window.print()
                this.can_print = false
            }, 500);
        },

        saveProforma() {
            if (this.operations_to_pay.length == 0) {
                this.warningToast('Merci de sélectionner au moins une prestation !')
                return
            }

            this.save_loading = true
            const data = {
                user_id: this.user_id,
                patient_id: this.info_patient.id,
                prestations: this.operations_to_pay,
                format_ref_facture: this.format_ref_facture,
                info_caissier: this.info_caissier,
                info_patient: {
                    nom_patient: this.info_patient.nom,
                    sexe: this.formatSexeMetier(this.info_patient.sexe),
                    telephone: this.info_patient.telephone_mobile,
                    num_dossier: this.info_patient.num_dossier,
                    age: this.info_patient.age
                },
            }
            this.$store.dispatch('saveProforma', data).then((response) => {
                if (response.success) {
                    this.successToast('Facture proforma enregistrée avec succès')
                    this.$router.push({ path: '/factures/facture-proforma'})
                } else {
                    if (response.code === 403) {
                        this.warningToast('Merci de sélectionner au moins une prestation puis réessayer !')
                    } else if (response === (500)) {
                        this.warningToast('Une erreur s\'est produite ! Merci de réessayer plustard')
                    }
                }

                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.is_error = true
            })
        },

        activateOtherPrestation() {
            let other = document.getElementById('oth');
            
            this.is_other_prestation = (other.checked)
        }
    }
}
